export const trackHeapEvent = (
  eventName: string,
  eventData?: Record<string, unknown>,
): void => {
  if (window.heap) {
    window.heap.track(eventName, eventData);
  }
};
